import { AuthService } from '@app/services';
import { InputType } from '@import/enums/input-type.enum';
import { Column } from '../classes';
import { TranslatableKey } from '@app/types/translatable.type';

/**
 * Boolean options are always these values
 */
export const BooleanOption: ColumnTypeOption[] = [
    {
        label: 'Yes',
        relatedLabels: ['true', '1'],
        translatableLabel: 'yes',
        value: 1,
    },
    {
        label: 'No',
        relatedLabels: ['false', '0'],
        translatableLabel: 'no',
        value: 0,
    },
];

/**
 * An option for enumerable input column type
 */
export interface ColumnTypeOption {
    label: string;
    relatedLabels?: string[]; // Used for fuzzy matching
    translatableLabel?: TranslatableKey;
    value: any;
}

/**
 * ColumnType are Known Columns Defined in Humi
 */
export interface ColumnType {
    csvColumn?: Column | null;
    label: string;
    relatedLabels?: string[]; // Used for fuzzy matching
    translatableLabel?: TranslatableKey;
    serializeName: string;
    input: InputType;
    options?: ColumnTypeOption[];
    required: boolean;
    requiredWith?: string[];
    conditionallyRequired?: boolean;
    rules?: string[][];
    getOptions?: (auth: AuthService) => Promise<any>;
}
